import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

/**
 * Splits text by URLs and returns React nodes: plain text and clickable links.
 * Use in a container with whiteSpace: 'pre-line' to preserve newlines.
 */
export function linkifyText(text) {
  if (!text || typeof text !== 'string') return text;
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) => {
    const isUrl = /^https?:\/\//i.test(part) || /^www\./i.test(part);
    const href = /^https?:\/\//i.test(part) ? part : `https://${part}`;
    if (isUrl) {
      return (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="order-edit-chat-link"
        >
          {part}
        </a>
      );
    }
    return part;
  });
}
